import { FC } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

type Props = {
	count?: number;
	isMobile?: boolean;
};

const OwnersListSkeleton: FC<Props> = ({ count = 10, isMobile }) => {
	return (
		<div className={cn('-mx-6', isMobile && '-mx-4')}>
			{Array.from({ length: count }, (_, index) => (
				<article
					key={index}
					className={cn(
						'px-6 py-4 flex items-center gap-4 hover:bg-popover-50',
						isMobile && 'px-4',
					)}>
					<Skeleton className='size-8 m-1.5 rounded-full' />
					<div className='grow'>
						<Skeleton className='h-3 w-16 my-1.5 rounded-full' />
						<Skeleton className='h-3 w-30 my-1.5 rounded-full' />
					</div>
					<Skeleton className='size-8 m-1.5 rounded-full' />
				</article>
			))}
		</div>
	);
};

export default OwnersListSkeleton;
